import { MessagingSystem } from "@/components/MessagingSystem";
import { ContactSupportDialog } from "@/components/ContactSupportDialog";
import { Navigation } from "@/components/Navigation";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";

export default function Messages() {
  return (
    <>
      <Navigation />
      <div className="container mx-auto py-8 pt-36">
        <div className="mb-6 flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-bold mb-2">Messages</h1>
            <p className="text-muted-foreground">
              Communicate with admins, landlords, and adjusters
            </p>
          </div>
          <ContactSupportDialog 
            trigger={
              <Button>
                <MessageCircle className="w-4 h-4 mr-2" />
                Contact Support
              </Button>
            }
          />
        </div>
        <MessagingSystem />
      </div>
    </>
  );
}
